import { useIsMobile } from "../context/MobileContext"
import { webInfo } from "../utils/types"
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const Faq:React.FC<{
    webInfo: webInfo
}>=({
    webInfo
})=>{

    const isMobile = useIsMobile()
    return(
        <div style={{fontFamily:'Digital', color:'#fff', marginTop:isMobile?'300px':'5vh', textAlign:'left', marginBottom:'30px'}}>
            FAQ
            <div style={{marginTop:'5px'}}>
                {webInfo?.faq?.map((question:any, index:any)=>{
                    return(
                        <Accordion key={index} style={{backgroundColor:'#1b1b1b', color:'#ececec', fontSize:isMobile?'10px':'12px', lineHeight:isMobile?'14px':'16px'}}>
                            <AccordionSummary
                            expandIcon={<ExpandMoreIcon sx={{color:'#fff'}}/>}
                            aria-controls={'panel'+index+'-content'}
                            id={'panel'+index+'-header'}
                            style={{fontSize:isMobile?'10px':''}}
                            >
                            {question.q}
                            </AccordionSummary>
                            <AccordionDetails>
                            {question.a}
                            </AccordionDetails>
                        </Accordion>
                    )
                })}
            </div>
        </div>
    )
}

export default Faq